export { default as reducer } from './phoneVerification.ducks';



// WEBPACK FOOTER //
// ./src/routes/Admin/ManagePhoneVerificationPage/index.ts